import { useEffect, useRef } from "react";
import Clarity from "@microsoft/clarity";
import { useSession } from "./session-provider";

const CLARITY_PROJECT_ID = "uwsb4oqaei";

interface ClarityProviderProps {
  children: React.ReactNode;
}

export function ClarityProvider({ children }: ClarityProviderProps) {
  const { session, isAuthenticated } = useSession();
  const isInitialized = useRef(false);
  const lastIdentifiedEmail = useRef<string | null>(null);

  // Initialize Clarity once on mount
  useEffect(() => {
    if (!isInitialized.current) {
      Clarity.init(CLARITY_PROJECT_ID);
      isInitialized.current = true;
    }
  }, []);

  // Identify user when session changes
  useEffect(() => {
    if (
      isAuthenticated &&
      session?.email &&
      session.email !== lastIdentifiedEmail.current
    ) {
      // Use email as the custom user ID
      // The friendly name combines first and last name if available
      const friendlyName = [session.first_name, session.last_name]
        .filter(Boolean)
        .join(" ");

      Clarity.identify(
        session.email,
        undefined, // custom-session-id (optional)
        undefined, // custom-page-id (optional)
        friendlyName || undefined
      );

      lastIdentifiedEmail.current = session.email;
    }
  }, [isAuthenticated, session?.email, session?.first_name, session?.last_name]);

  return <>{children}</>;
}
